import { FeedbackVoter } from '@/hooks/Feedback/interfaces';
import { Box, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';

type FeedbackVotersTooltipProps = {
  voters?: FeedbackVoter[] | null;
  total: number;
};

export const FeedbackVotersTooltip: React.FC<FeedbackVotersTooltipProps> = ({
  voters,
  total,
  children,
}) => {
  const list = voters || [];
  const remaining = Math.max(total - list.length, 0);

  return (
    <Tooltip
      isDisabled={list.length === 0}
      hasArrow
      placement="top"
      label={
        <Box>
          {list.map((voter) => (
            <Text key={voter.id} fontSize="sm">
              {voter.name}
            </Text>
          ))}
          {remaining > 0 && <Text fontSize="sm">+{remaining}</Text>}
        </Box>
      }
    >
      {/* span lets the tooltip work even when the button is disabled */}
      <span>{children}</span>
    </Tooltip>
  );
};
